<mat-card>

  <mat-card-content>
    <mat-card-title class="variable-title">{{title}}</mat-card-title>

    <div class="filters">
      <mat-form-field class="search-field">
        <mat-label>Search</mat-label>
        <input [(ngModel)]="filterText" (keyup)="applyFilter($event)" matInput>
      </mat-form-field>

      <mat-form-field class="stage-filter-field">
        <mat-label>Filter Scope</mat-label>
        <mat-select multiple [(value)]="scopeFilters" placeholder="Filter Scopes" (selectionChange)="applyFilters()">
          <mat-checkbox [indeterminate]="isIndeterminate()" [checked]="isChecked()" (click)="$event.stopPropagation()"
            (change)="toggleSelection($event)" onkeyup="$event.stopPropagation()" tabIndex="0">
            Select All
          </mat-checkbox>
          @for (scope of scopeOptions; track scope) {
            <mat-option [value]="scope">{{scope}}</mat-option>
          }
        </mat-select>
      </mat-form-field>

      <div class="dots">
        @if (!statusFilters.includes('added') && title ==='After') {
          <button mat-raised-button class="green dot-unselected button"
          (click)="addStatusFilter('added')" matTooltip="Toggle Added Variables" matTooltipPosition="above">Added</button>
        }
        @if (statusFilters.includes('added') && title ==='After') {
          <button mat-raised-button class="green button"
          (click)="removeStatusFilter('added')" matTooltip="Toggle Added Variables" matTooltipPosition="above">Added</button>
        }

        @if (!statusFilters.includes('deleted') && title ==='Before') {
          <button mat-raised-button class="red dot-unselected button"
          (click)="addStatusFilter('deleted')" matTooltip="Toggle Deleted Variables" matTooltipPosition="above">Deleted</button>
        }
        @if (statusFilters.includes('deleted') && title ==='Before') {
          <button mat-raised-button class="red button"
          (click)="removeStatusFilter('deleted')" matTooltip="Toggle Deleted Variables" matTooltipPosition="above">Deleted</button>
        }

        @if (!statusFilters.includes('edited')) {
          <button mat-raised-button class="blue dot-unselected button" (click)="addStatusFilter('edited')"
          matTooltip="Toggle Modified Variables" matTooltipPosition="above">Modified</button>
        }
        @if (statusFilters.includes('edited')) {
          <button mat-raised-button class="blue button" (click)="removeStatusFilter('edited')"
          matTooltip="Toggle Modified Variables" matTooltipPosition="above">Modified</button>
        }

        @if (!statusFilters.includes('unchanged')) {
          <button mat-raised-button class="gray dot-unselected button"
          (click)="addStatusFilter('unchanged')" matTooltip="Toggle Unchanged Variables" matTooltipPosition="above">Unchanged</button>
        }
        @if (statusFilters.includes('unchanged')) {
          <button mat-raised-button class="gray button"
          (click)="removeStatusFilter('unchanged')" matTooltip="Toggle Unchanged Variables" matTooltipPosition="above">Unchanged</button>
        }
      </div>

    </div>

    <table mat-table matSort [dataSource]="dataSource" class="mat-elevation-z8">

      <ng-container matColumnDef="name">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Name </th>
        <td mat-cell *matCellDef="let element" matTooltip="{{element.name}}" matTooltipPosition="above"
        matTooltipShowDelay="500"> {{element.name}} </td>
      </ng-container>

      <ng-container matColumnDef="value">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Value </th>
        <td mat-cell *matCellDef="let element" matTooltip="{{element.value}}" matTooltipPosition="above"
        matTooltipShowDelay="500"> {{element.value}} </td>
      </ng-container>

      <ng-container matColumnDef="scope">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Scope </th>
        <td mat-cell class="centered-cell" *matCellDef="let element" matTooltip="{{element.scope}}"
        matTooltipPosition="above" matTooltipShowDelay="500"> {{element.scope}} </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row [ngClass]="getStatusClass(row)" *matRowDef="let row; columns: displayedColumns;"></tr>

    </table>

  </mat-card-content>
</mat-card>